"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var bulk_picker_popup_component_1 = require("../../dialogs/bulk-picker/bulk-picker-popup.component");
var material_1 = require("@angular/material");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var Observable_1 = require("rxjs/Observable");
var form_resolution_service_1 = require("../../../../shared/services/api/form-resolution.service");
var type_subtype_select_dialog_component_1 = require("../../../../shared/dialogs/advanced/type-subtype-select/type-subtype-select-dialog.component");
var dialog_config_helper_1 = require("../../../../shared/utils/dialog-config-helper");
var type_subtype_select_dialog_data_1 = require("../../../../shared/dialogs/advanced/type-subtype-select/model/type-subtype-select-dialog-data");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var dialog_action_1 = require("../../enums/dialog-action");
var root_category_provider_service_1 = require("../../../../shared/services/api/root-category-provider.service");
var url_and_query_params_1 = require("../../../../shared/utils/url-and-query-params");
var search_filter_decorator_service_1 = require("../../../../shared/services/api/search-filter-decorator.service");
var bulk_picker_search_filter_context_1 = require("../../model/bulk-picker-search-filter-context");
var TableButtonsComponent = /** @class */ (function () {
    function TableButtonsComponent(formResolutionService, rootCategoryProviderService, classifierService, dialog, searchFilterProviderService) {
        this.formResolutionService = formResolutionService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.classifierService = classifierService;
        this.dialog = dialog;
        this.searchFilterProviderService = searchFilterProviderService;
        this.isPopupOpened = new core_1.EventEmitter();
        this._unmodifiedSubEntities = [];
        this._selectedSubEntities = [];
        this._destroy$ = new Subject_1.Subject();
    }
    TableButtonsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buttonConfigs.forEach(function (buttonConfig) {
            buttonConfig.title = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(buttonConfig.stringTitle)));
        });
        if (this.entity) {
            this.actionNotifier.pipe(operators_1.concatMap(function (action) {
                if (_this._isDrawerOpened) {
                    if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_SAVE_ACTION) {
                        var responseEntity = action.data.getData();
                        _this._drawerEntity = responseEntity.getId() !== -1 ? responseEntity : null;
                    }
                    else if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_CLOSE_ACTION) {
                        _this._isDrawerOpened = false;
                        return _this.openBulkPickerPopup(_this._lastClickedButtonConfig, _this.getBulkPickerDialogConfig());
                    }
                }
                return of_1.of();
            }), operators_1.takeUntil(this._destroy$))
                .subscribe(function (dialogResult) {
                if (dialogResult) {
                    _this.onBulkPickerPopupClosed(dialogResult);
                }
            });
        }
    };
    TableButtonsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    TableButtonsComponent.prototype.onTableButtonClick = function (buttonConfig) {
        var _this = this;
        var popupConfig = bulk_picker_popup_component_1.BulkPickerPopupComponent.getConfig(this.entity, buttonConfig, this.mainEntityMetaField, this.currentLanguageId, this.form, this.categoryId, this.subEntityFieldId, this.rootTableTitle, this.mainEntityImageFieldName, [], null, this.buttonConfigs.indexOf(buttonConfig), this.idPrefix);
        this.openBulkPickerPopup(buttonConfig, popupConfig)
            .take(1)
            .takeUntil(this._destroy$)
            .subscribe(function (dialogResult) {
            if (dialogResult) {
                _this.onBulkPickerPopupClosed(dialogResult);
            }
        });
    };
    TableButtonsComponent.prototype.openBulkPickerPopup = function (buttonConfig, popupConfig) {
        var _this = this;
        if (!this._unmodifiedSubEntities.length) {
            this._unmodifiedSubEntities = this.entity.getProperty(this.subEntityCategoryId).value
                .map(function (subEntity) { return subEntity.clone(); });
        }
        this.isPopupOpened.emit(true);
        return this.dialog.open(bulk_picker_popup_component_1.BulkPickerPopupComponent, popupConfig).afterClosed()
            .pipe(operators_1.concatMap(function (dialogResult) {
            if (dialogResult.action === dialog_action_1.DialogAction.NEW_ENTITY) {
                _this._selectedSubEntities = dialogResult.entities;
                _this._drawerEntity = null;
                _this._isDrawerOpened = true;
                _this._lastClickedButtonConfig = buttonConfig;
                return _this.navigateToNewEntity();
            }
            else {
                return of_1.of(dialogResult);
            }
        }));
    };
    TableButtonsComponent.prototype.navigateToNewEntity = function () {
        var _this = this;
        var mainEntityCategoryName = this.mainEntityMetaField['compoundCategorySystemName'];
        var searchFilter = this._lastClickedButtonConfig.searchFilter;
        if (this.mainEntityTypeConfigs) {
            var hasTypeAsFilter = this.mainEntityTypeConfigs.type &&
                searchFilter.lookupFieldSystemName === this.mainEntityTypeConfigs.type.field;
            var hasSubTypeAsFilter = this.mainEntityTypeConfigs.subType &&
                searchFilter.lookupFieldSystemName === this.mainEntityTypeConfigs.subType.field;
            if (hasTypeAsFilter) {
                if (this.mainEntityTypeConfigs.subType) {
                    return this.classifierService.loadClassifiersByParent(this.mainEntityTypeConfigs.subType.category, searchFilter.lookupFieldValue).pipe(operators_1.switchMap(function (classifiersResponse) {
                        var subTypeClassifiers = classifiersResponse.getData();
                        var subTypeClassifiersCount = classifiersResponse.getMetaData().getCount();
                        if (subTypeClassifiersCount === 0) {
                            return _this.openNewEntityDrawer(mainEntityCategoryName, searchFilter, {
                                'typeId': searchFilter.lookupFieldValue,
                                'subTypeId': null
                            });
                        }
                        else if (subTypeClassifiersCount === 1) {
                            return _this.openNewEntityDrawer(mainEntityCategoryName, searchFilter, {
                                'typeId': searchFilter.lookupFieldValue,
                                'subTypeId': subTypeClassifiers.pop().getId()
                            });
                        }
                        else {
                            return _this.chooseTypeAndOpenNewEntityDrawer(mainEntityCategoryName, searchFilter);
                        }
                    }));
                }
                else {
                    return this.openNewEntityDrawer(mainEntityCategoryName, searchFilter, {
                        'typeId': searchFilter.lookupFieldValue,
                        'subTypeId': null
                    });
                }
            }
            else if (hasSubTypeAsFilter) {
                return this.classifierService.loadClassifiersByIds(this.mainEntityTypeConfigs.subType.category, [searchFilter.lookupFieldValue]).pipe(operators_1.concatMap(function (response) {
                    var subTypeClassifier = response.getData()[0];
                    if (subTypeClassifier) {
                        return _this.openNewEntityDrawer(mainEntityCategoryName, searchFilter, {
                            'typeId': subTypeClassifier.getProperty(_this.mainEntityTypeConfigs.type.field).value,
                            'subTypeId': searchFilter.lookupFieldValue,
                        });
                    }
                    return of_1.of();
                }));
            }
            else {
                return this.chooseTypeAndOpenNewEntityDrawer(mainEntityCategoryName, searchFilter);
            }
        }
        else {
            return this.openNewEntityDrawer(mainEntityCategoryName, searchFilter, null);
        }
    };
    TableButtonsComponent.prototype.openNewEntityDrawer = function (mainEntityCategoryName, searchFilter, typeSubTypeSelectDialogResult) {
        var _this = this;
        var transientFields$ = this.constructTransientFields(searchFilter, typeSubTypeSelectDialogResult);
        var formProperties$ = this.formResolutionService.getFormProperties(mainEntityCategoryName, typeSubTypeSelectDialogResult.typeId, typeSubTypeSelectDialogResult.subTypeId);
        return Observable_1.Observable.zip(formProperties$, transientFields$).pipe(operators_1.map(function (data) {
            var formProperties = data[0];
            var transientFields = data[1];
            _this.form.actions.newEntityPopup(formProperties.editFormName, mainEntityCategoryName, formProperties.editFormId, transientFields);
        }));
    };
    TableButtonsComponent.prototype.chooseTypeAndOpenNewEntityDrawer = function (mainEntityCategoryName, searchFilter) {
        var _this = this;
        var dialogData = new type_subtype_select_dialog_data_1.TypeSubtypeSelectDialogData(this.mainEntityTypeConfigs, searchFilter.lookupFieldValue && [searchFilter.lookupFieldValue]);
        return this.dialog.open(type_subtype_select_dialog_component_1.TypeSubtypeSelectDialogComponent, dialog_config_helper_1.DialogConfigHelper.getTypeSubtypeSelectDialogConfig(dialogData))
            .afterClosed()
            .pipe(operators_1.concatMap(function (dialogResult) {
            if (dialogResult) {
                return _this.openNewEntityDrawer(mainEntityCategoryName, searchFilter, {
                    'typeId': dialogResult.type.getId(),
                    'subTypeId': dialogResult.subType && dialogResult.subType.getId()
                });
            }
            else {
                return _this.openBulkPickerPopup(_this._lastClickedButtonConfig, _this.getBulkPickerDialogConfig());
            }
        }));
    };
    TableButtonsComponent.prototype.onBulkPickerPopupClosed = function (dialogResult) {
        if (dialogResult.action === dialog_action_1.DialogAction.CANCEL) {
            this.entity.getProperty(this.subEntityCategoryId).value = this._unmodifiedSubEntities;
        }
        this._selectedSubEntities = [];
        this._unmodifiedSubEntities = [];
        this.isPopupOpened.emit(false);
    };
    TableButtonsComponent.prototype.getBulkPickerDialogConfig = function () {
        var config = bulk_picker_popup_component_1.BulkPickerPopupComponent.getConfig(this.entity, this._lastClickedButtonConfig, this.mainEntityMetaField, this.currentLanguageId, this.form, this.categoryId, this.subEntityFieldId, this.rootTableTitle, this.mainEntityImageFieldName, [], null, this.buttonConfigs.indexOf(this._lastClickedButtonConfig), this.idPrefix);
        config.data.selectedSubEntities = this._selectedSubEntities;
        if (this._drawerEntity) {
            config.data.newEntity = this._drawerEntity;
            this._drawerEntity = null;
        }
        else {
            config.data.newEntity = null;
        }
        return config;
    };
    TableButtonsComponent.prototype.constructTransientFields = function (searchFilter, dialogResult) {
        var _this = this;
        var transientFields = {};
        if (searchFilter.lookupFieldSystemName) {
            transientFields[searchFilter.lookupFieldSystemName] = searchFilter.lookupFieldValue;
        }
        dialogResult.typeId && (transientFields[this.mainEntityTypeConfigs.type.field] = dialogResult.typeId);
        dialogResult.subTypeId && (transientFields[this.mainEntityTypeConfigs.subType.field] = dialogResult.subTypeId);
        return this.rootCategoryProviderService.getRootCategoryId(this.categoryId).pipe(operators_1.switchMap(function (rootCategoryId) {
            return _this.rootCategoryProviderService.getRootEntityId(rootCategoryId, _this.categoryId, _this.entity)
                .map(function (rootEntityId) {
                transientFields[url_and_query_params_1.UrlAndQueryParams.rootEntityId] = rootEntityId;
                transientFields[url_and_query_params_1.UrlAndQueryParams.rootCategoryId] = rootCategoryId;
                return transientFields;
            });
        }), operators_1.switchMap(function () {
            if (_this.searchFilterProviderService) {
                return _this.searchFilterProviderService.getTransientFields(transientFields, new bulk_picker_search_filter_context_1.BulkPickerSearchFilterContext(_this.categoryId, _this.subEntityFieldId, _this.entity, _this._lastClickedButtonConfig, _this.buttonConfigs.indexOf(_this._lastClickedButtonConfig)));
            }
            else {
                return of_1.of(transientFields);
            }
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], TableButtonsComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableButtonsComponent.prototype, "buttonConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], TableButtonsComponent.prototype, "mainEntityMetaField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableButtonsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_dynamic_forms_ui_1.DynamicFormComponent)
    ], TableButtonsComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableButtonsComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableButtonsComponent.prototype, "subEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableButtonsComponent.prototype, "subEntityFieldId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableButtonsComponent.prototype, "rootTableTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableButtonsComponent.prototype, "mainEntityImageFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TableButtonsComponent.prototype, "mainEntityTypeConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], TableButtonsComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableButtonsComponent.prototype, "idPrefix", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], TableButtonsComponent.prototype, "isPopupOpened", void 0);
    TableButtonsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-table-buttons',
            styles: [require('./table-buttons.component.css')],
            template: require('./table-buttons.component.html')
        }),
        __param(4, core_1.Optional()),
        __metadata("design:paramtypes", [form_resolution_service_1.FormResolutionService,
            root_category_provider_service_1.RootCategoryProviderService,
            idm_classifier_service_client_js_1.ClassifierService, material_1.MatDialog,
            search_filter_decorator_service_1.SearchFilterDecoratorService])
    ], TableButtonsComponent);
    return TableButtonsComponent;
}());
exports.TableButtonsComponent = TableButtonsComponent;
//# sourceMappingURL=table-buttons.component.js.map